var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_17684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6619 9.05915C22.2422 2.81239 16.7932 0 12.0067 0H11.9932C7.22025 0 1.75772 2.79887 0.337999 9.04563C-1.24397 16.0225 3.0287 21.9313 6.89574 25.6496C8.26641 26.9763 10.0992 27.7181 12.0067 27.7183C13.8456 27.7183 15.6845 27.0287 17.1042 25.6496C20.9712 21.9313 25.2439 16.0361 23.6619 9.05915ZM12.0067 15.8332C11.4474 15.8332 10.8936 15.7231 10.3768 15.509C9.86008 15.295 9.39055 14.9813 8.99505 14.5858C8.59956 14.1903 8.28583 13.7207 8.07178 13.204C7.85774 12.6872 7.74758 12.1334 7.74758 11.5741C7.74758 11.0148 7.85774 10.4609 8.07178 9.94418C8.28583 9.42743 8.59956 8.95791 8.99505 8.56241C9.39055 8.16691 9.86008 7.85318 10.3768 7.63914C10.8936 7.4251 11.4474 7.31493 12.0067 7.31493C13.1363 7.31493 14.2197 7.76366 15.0184 8.56241C15.8172 9.36115 16.2659 10.4445 16.2659 11.5741C16.2659 12.7037 15.8172 13.787 15.0184 14.5858C14.2197 15.3845 13.1363 15.8332 12.0067 15.8332Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_17684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 27.7183,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappin);
export default __webpack_public_path__ + "static/media/mappin.233adfa198acfd16dd1eb2a4d41b12c1.svg";
export { ForwardRef as ReactComponent };